<div class="panel-header">
  <!-- Button style trigger -->
  @if (triggerConfig().style === 'button') {
    <button
      #triggerBtn
      accredible-button-flat
      [id]="triggerBtnId"
      [class.full-width]="triggerConfig().width === 'full'"
      [attr.data-cy]="dataCy()"
      [attr.aria-expanded]="!disabled() ? expanded() : null"
      [attr.aria-controls]="!disabled() ? panelContentId : null"
      [attr.aria-label]="
        expanded() ? triggerConfig().collapseAriaLabel : triggerConfig().expandAriaLabel
      "
      [icon]="'chevron-down'"
      [iconSize]="'10px'"
      [rotateIcon]="expanded()"
      (click)="onTrigger()">
      {{ expanded() ? triggerConfig().collapseText : triggerConfig().expandText }}
    </button>
  } @else {
    @if (triggerConfig().style === 'div') {
      <div
        class="div-trigger"
        role="button"
        tabindex="0"
        [id]="triggerBtnId"
        [class.full-width]="triggerConfig().width === 'full'"
        [attr.data-cy]="dataCy()"
        [attr.aria-expanded]="!disabled() ? expanded() : null"
        [attr.aria-controls]="!disabled() ? panelContentId : null"
        [attr.aria-label]="
          expanded() ? triggerConfig().collapseAriaLabel : triggerConfig().expandAriaLabel
        "
        (click)="onTrigger()"
        (keyup.enter)="onTrigger()">
        <span>{{ expanded() ? triggerConfig().collapseText : triggerConfig().expandText }} </span>
        <accredible-icon [icon]="expanded() ? 'chevron-up' : 'chevron-down'" />
      </div>
    } @else {
      <!-- Link style trigger -->
      <button
        #triggerBtn
        accredible-link
        [id]="triggerBtnId"
        [class.full-width]="triggerConfig().width === 'full'"
        [attr.data-cy]="dataCy()"
        [attr.aria-expanded]="!disabled() ? expanded() : null"
        [attr.aria-controls]="!disabled() ? panelContentId : null"
        [attr.aria-label]="
          expanded() ? triggerConfig().collapseAriaLabel : triggerConfig().expandAriaLabel
        "
        [icon]="'chevron-down'"
        [rotateIcon]="expanded()"
        (click)="onTrigger()">
        {{ expanded() ? triggerConfig().collapseText : triggerConfig().expandText }}
      </button>
    }
  }
</div>

@if (!disabled()) {
  <div
    #expandableRegionEl
    class="panel-content"
    role="region"
    [id]="panelContentId"
    [attr.aria-label]="expandableRegionAriaLabel()"
    (@expansionPanelAnimation.done)="onExpand()"
    [@expansionPanelAnimation]="
      expanded() ? expansionPanelState.expanded : expansionPanelState.collapsed
    ">
    <ng-content />
  </div>
}
